// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { CircularProgress, Stack, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { LoanProductTablePropsType } from "../../../types/container.type";
import { BaseButton } from "../../../components/button/styled";
// import DeleteIcon from '@mui/icons-material/Delete';

export const LoanProductTable: React.FC<LoanProductTablePropsType> = ({ rows, handleItemClick, selectedLoanProductId }) => {
    const loanProductTableHeaders = ["Product Name", "Interest Rate", "Status", "Action"];

    return (
        <BaseTable headers={loanProductTableHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{row?.name}</TableCell>
                            <TableCell>{`${row?.interestRate}%`}</TableCell>
                            <TableCell>{row?.status.charAt(0).toUpperCase() + row?.status.slice(1)}</TableCell>
                            <TableCell>
                                <Stack direction="row" gap="calc(var(--flex-gap)/4)">
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--primary-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize="14px"
                                        onClick={(e) => handleItemClick(e, row.id, "edit")}
                                    >
                                        Edit
                                    </BaseButton>
                                    {/* <BaseButton
                                        variant="contained"
                                        bgcolor="var(--text-salmon-pink-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize="14px"
                                        onClick={(e) => handleItemClick?.(e, { loanProductId: row.id, institutionId: row.institution }, "delete")}
                                    >
                                        {selectedLoanProductId !== null && selectedLoanProductId === row.id ? (
                                            <CircularProgress color="inherit" className="loader" />
                                        ) : (
                                            <DeleteIcon />
                                        )}
                                    </BaseButton> */}
                                </Stack>
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
